import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Loading from "../../components/views/Loading";

interface ProtectedRouteArgs {
  component: any;
  exact: boolean;
  path: string;
}

// Define a wrapper component to handle the auth check manually
const ProtectedRouteComponent = ({ component: Component, ...rest }: any) => {
  const { isAuthenticated, isLoading } = useAuth0();

  // Handle the loading state
  if (isLoading) {
    return <Loading />;
  }

  // Create a render function that conditionally renders the component or redirects
  const renderComponent = (props: any) => 
    isAuthenticated ? (
      <Component {...props} />
    ) : (
      <Redirect to="/" />
    );

  return <Route {...rest} render={renderComponent} />;
};

// The main ProtectedRoute component
const ProtectedRoute = ({ component, path, exact }: ProtectedRouteArgs) => {
  return (
    <ProtectedRouteComponent 
      component={component}
      exact={exact}
      path={path}
    />
  );
};

export default ProtectedRoute;
